import React, { useState } from 'react'
import { withTheme } from 'theming'
import AddSection from '../addSection'
import EditMenu from '../editMenu'
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu'
import CustomImage from '../../customImage/customImage'
import useTemplateHook from '../templateHook'
import { isEmpty } from 'lodash'

const ExtensiveCarouselCenterAligned = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  onCopy,
  theme,
  onAdd,
}) => {
  const { data, id } = componentData
  const { customNavigate } = useTemplateHook()
  const [hoverState, setHoverState] = useState('')

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  function LeftArrow() {
    const { isFirstItemVisible, scrollPrev } = React.useContext(VisibilityContext)

    return (
      <button
        className={` absolute left-[3vw] top-1/2 z-10  border-0 bg-transparent px-0 hidden ${
          data?.slide_data.length > 4 && 'lg:block'
        } `}
        disabled={isFirstItemVisible}
        onClick={() => scrollPrev()}
        title="Previous Item"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{
            width: '25px',
            height: '25px',
          }}
        >
          <path
            d="m9 6 11.928 11.928L9 29.856"
            transform="rotate(180 11.171 15.282)"
            style={{
              fill: 'none',
              stroke: theme.c4,
              strokeWidth: 2,
            }}
          />
        </svg>
      </button>
    )
  }

  function RightArrow() {
    const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext)

    return (
      <button
        className={` absolute right-[2.25vw] top-1/2 z-10 border-0 bg-transparent px-0 hidden ${
          data?.slide_data.length > 4 && 'lg:block'
        } `}
        disabled={isLastItemVisible}
        onClick={() => scrollNext()}
        title="Next Item"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{
            width: '25px',
            height: '25px',
          }}
        >
          <path
            d="m9 6 11.928 11.928L9 29.856"
            transform="translate(-8.293 -5.293)"
            style={{
              fill: 'none',
              stroke: theme.c4,
              strokeWidth: 2,
            }}
          />
        </svg>
      </button>
    )
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  return (
    <div
      className={`w-full relative ${isEdit && hoverState && 'component-hover-class'}`}
      style={{
        backgroundColor: getStyleValue('component_background', 'primary_color', theme.c1),
      }}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onDelete={() => onDelete(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
          onEdit={() => handleModal()}
          onCopy={() => onCopy(id)}
        />
      )}
      <div className="py-[16px] lg:py-8">
        <h2
          style={{
            color: getStyleValue('heading', 'color', theme.c2),
            fontFamily: getStyleValue('heading', 'font', ''),
            textAlign: getStyleValue('heading', 'alignment', ''),
          }}
          className={`xl:text-3xl md:text-xl text-xs ${getStyleValue(
            'heading',
            'font_format',
            'font-bold',
          )} sm:mb-[2vw] mb-6 2xl:px-32 xl:px-24 md:px-16 sm:px-10 px-[10px]`}
        >
          {data?.heading}
        </h2>
        <div className="w-full text-[#fefefe]">
          <ScrollMenu
            LeftArrow={LeftArrow}
            RightArrow={RightArrow}
            wrapperClassName={`w-full md:mt-4 ${
              data?.slide_data.length < 5 && 'center-react-scrolling-menu'
            }  `}
          >
            {data?.slide_data &&
              data?.slide_data.map((info, index) => (
                <Card
                  key={index}
                  itemId={`index${index}`}
                  index={index}
                  info={info}
                  handleRedirect={handleRedirect}
                  theme={theme}
                  headingStyle={{
                    color: getStyleValue('card_heading_style', 'color', theme.c3),
                    fontFamily: getStyleValue('card_heading_style', 'font', ''),
                  }}
                  headingFormat={getStyleValue(
                    'card_heading_style',
                    'font_format',
                    'font-semibold',
                  )}
                />
              ))}
          </ScrollMenu>
        </div>
      </div>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

function Card({ index, info, handleRedirect, theme, headingStyle, headingFormat }) {
  const { getTemplateImage } = useTemplateHook()
  return (
    <div
      key={index}
      className={`${
        !index && 'ml-2 2xl:ml-32 xl:ml-24 md:ml-16 sm:ml-10'
      } 2xl:w-[305px] lg:w-[265px] md:w-[200px] sm:w-[170px] w-[139px] 2xl:h-[210px] lg:h-[182px] md:h-[137px] sm:h-[117px] h-[122px] sm:mr-[2.25vw] mr-6 static-img-scale `}
      style={{
        // color: theme.c4,
        cursor: 'pointer',
        position: 'relative',
      }}
      onClick={() => handleRedirect(info?.link)}
    >
      <div className="border rounded-lg overflow-hidden w-full">
        <CustomImage
          imageUrl={getTemplateImage(info?.image_s3key)}
          imgClass="z-0 w-full h-auto  static-img-scale "
          imgStyle={{ aspectRatio: '1.784' }}
          loaderClass="z-0 w-full h-2/3"
          loaderStyle={{
            background: '#5A5A5A50',
          }}
          imgAlt={'class img"'}
        />
      </div>
      <p
        className={`font-semibold w-full 2xl:text-lg xl:text-base lg:text-sm sm:text-xs text-[10px] mt-[8px] ${headingFormat} text-center`}
        style={{ marginBottom: '0', ...headingStyle }}
      >
        {info?.heading}
      </p>
    </div>
  )
}

export default withTheme(ExtensiveCarouselCenterAligned)
